import React from 'react';
import Suspense from '@atlaskit/react-ufo/suspense';
import { useCommandPaletteShortcut } from '@atlassian/jira-command-palette-common/src/controllers/use-command-palette-shortcut/index.tsx';
import type { CommandPaletteModalProps } from '@atlassian/jira-command-palette/src/ui/modal/types.tsx';
import { CommandPaletteWrapper } from '@atlassian/jira-command-palette/src/ui/wrapper/index.tsx';
import Shortcuts from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcuts/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { JiraCommandPaletteErrorBoundary } from './common/ui/error-boundary/index.tsx';
import { CommandPaletteIntegration } from './ui/index.tsx';

const InternalCommandPalette = (props: CommandPaletteModalProps) => {
	const { keyMap: commandPaletteKeyMap } = useCommandPaletteShortcut();

	return (
		<UFOSegment name="command-palette">
			<Shortcuts keyMap={commandPaletteKeyMap} />
			<Suspense interactionName="jira-command-palette" fallback={<></>}>
				<CommandPaletteIntegration {...props} />
			</Suspense>
		</UFOSegment>
	);
};

export const JiraCommandPalette = (props: CommandPaletteModalProps) => (
	<JiraCommandPaletteErrorBoundary id="jira-command-palette-integration">
		<CommandPaletteWrapper>
			<InternalCommandPalette {...props} />
		</CommandPaletteWrapper>
	</JiraCommandPaletteErrorBoundary>
);

export default JiraCommandPalette;
